const config = {
  blockCheck: true,
  mbAudioItemData: [
    {
      id: 'a01',
      src: 'games/page032_game0/audio/43_banana.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page032_game0/img/audioOn.png', iconOff: 'games/page032_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: -50,
        x: 67,
      },
      width: '48px',
      height: '48px',
      unit: 'px',
    },
    {
      id: 'a02',
      src: 'games/page032_game0/audio/46_lemon.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page032_game0/img/audioOn.png', iconOff: 'games/page032_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: -50 - 10,
        x: 100 - 57,
      },
      width: '48px',
      height: '48px',
      unit: 'px',
    },
    {
      id: 'a03',
      src: 'games/page032_game0/audio/44_pear.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page032_game0/img/audioOn.png', iconOff: 'games/page032_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: -25,
        x: 67,
      },
      width: '48px',
      height: '48px',
      unit: 'px',
    },
    {
      id: 'a04',
      src: 'games/page032_game0/audio/45_cherry.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page032_game0/img/audioOn.png', iconOff: 'games/page032_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: -50,
        x: 67,
      },
      width: '48px',
      height: '48px',
      unit: 'px',
    },
  ],
  mainImage: {
    src: 'games/page032_game0/img/bcg.webp',
  },

  multiconnect: false,
  globalItemsConfig: {
    hookPoint: {
      rad: 0,
    },
  },
  dontCheckIncorrectLines: false,
  dontAcceptIncorrectLines: true,

  linesStyle: {
    colors: {
      bad: 'red',
      good: 'green',
      neutral: '#4cb9fa',
    },
    size: 5,
  },
  rules: [
    { connectId: 1, connectedWith: 5 },
    { connectId: 2, connectedWith: 6 },
    { connectId: 3, connectedWith: 7 },
    { connectId: 4, connectedWith: 8 },
  ],

  autoCheck: true,
  numberOfGoodLines: 3,
  sounds: [
    { src: 'games/page032_game0/audio/false.mp3', id: 'endConnect' },
    { src: 'games/page032_game0/audio/click.mp3', id: 'startConnect' },
    { src: 'games/page032_game0/audio/43_banana.mp3', id: 'banana' },
    { src: 'games/page032_game0/audio/44_pear.mp3', id: 'pear' },
    { src: 'games/page032_game0/audio/45_cherry.mp3', id: 'cherry' },
    { src: 'games/page032_game0/audio/46_lemon.mp3', id: 'lemon' },
  ],
  groups: [
    {
      name: 'left',
      disableShuffle: false,
      items: [
        {
          connectId: 1,
          audioId: 'banana',
          image: { src: 'games/page032_game0/img/banan.webp' },
          imageStyle: { position: 'absolute', width: '200px', height: '215px' },
          pos: {
            x: 466,
            y: 834,
            width: 200,
            height: 215,
          },
          cssStyle: { 'background-color': 'rgba(255, 255, 255, 0.01)' },
          hooks: [{ x: 100, y: 1 }],
        },
        {
          connectId: 2,
          audioId: 'lemon',
          image: { src: 'games/page032_game0/img/cytryna.webp' },
          imageStyle: { position: 'absolute', width: '200px', height: '215px' },
          pos: {
            x: 708,
            y: 834,
            width: 200,
            height: 215,
          },
          cssStyle: { 'background-color': 'rgba(255, 255, 255, 0.01)' },
          hooks: [{ x: 100, y: 1 }],
        },
        {
          connectId: 3,
          audioId: 'pear',
          image: { src: 'games/page032_game0/img/gruszka.webp' },
          imageStyle: { position: 'absolute', width: '200px', height: '215px' },
          pos: {
            x: 952,
            y: 834,
            width: 200,
            height: 215,
          },
          cssStyle: { 'background-color': 'rgba(255, 255, 255, 0.01)' },
          hooks: [{ x: 100, y: 1 }],
        },
        {
          connectId: 4,
          audioId: 'cherry',
          image: { src: 'games/page032_game0/img/wisnia.webp' },
          imageStyle: { position: 'absolute', width: '200px', height: '215px' },
          pos: {
            x: 1190,
            y: 834,
            width: 200,
            height: 215,
          },
          cssStyle: { 'background-color': 'rgba(255, 255, 255, 0.01)' },
          hooks: [{ x: 100, y: 1 }],
        },
      ],
    },
    {
      name: 'right',
      disableShuffle: true,
      items: [
        {
          audio: 'a01',
          connectId: 5,
          image: { src: 'games/page032_game0/img/cherry_t.png' },
          imageStyle: { position: 'absolute', width: '135px', height: '94px' },
          pos: {
            x: 800,
            y: 476,
            width: 197,
            height: 108,
          },
          cssStyle: { 'background-color': 'rgba(255, 255, 255, 0.01)' },
          hooks: [{ x: 197 / 2, y: 108 }],
        },
        {
          audio: 'a02',
          connectId: 6,
          image: { src: 'games/page032_game0/img/lemon_t.png' },
          imageStyle: { position: 'absolute', width: '174px', height: '221px' },
          pos: {
            x: 582,
            y: 486,
            width: 123,
            height: 218,
          },
          cssStyle: { 'background-color': 'rgba(255, 255, 255, 0.01)' },
          hooks: [{ x: 123 / 2, y: 218 }],
        },
        {
          audio: 'a03',
          connectId: 7,
          image: { src: 'games/page032_game0/img/cherry_t.png' },
          imageStyle: { position: 'absolute', width: '170px', height: '171px' },
          pos: {
            x: 1336,
            y: 666,
            width: 197,
            height: 108,
          },
          cssStyle: { 'background-color': 'rgba(255, 255, 255, 0.01)' },
          hooks: [{ x: 197 / 2, y: 108 }],
        },
        {
          audio: 'a04',
          connectId: 8,
          image: { src: 'games/page032_game0/img/cherry_t.png' },
          imageStyle: { position: 'absolute', width: '125px', height: '216px' },
          pos: {
            x: 265,
            y: 566,
            width: 197,
            height: 108,
          },
          cssStyle: { 'background-color': 'rgba(255, 255, 255, 0.01)' },
          hooks: [{ x: 197 / 2, y: 108 }],
        },
      ],
    },
  ],
};
export default config;
